<template>
  <div>
    <v-layout  wrap>
      <v-flex xs12>
        <v-card flat tile>
          <v-layout  wrap>
            <v-flex xs12>
              <v-img
              v-if="baseURL+about.coverpic"
                height="100vh"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.1)"
                :src="baseURL+about.coverpic"
                style="opacity: 1"
              >
                <v-layout justify-end wrap fill-height>
                  <v-flex xs10 align-self-center>
                    <v-layout  justify-start fill-height>
                      <v-flex v-if="about.heading" pr-7  xs12 lg9 align-self-center text-center> <span
                          style="
                            font-family: poppinssemibold;
                            font-size: 28px;
                            color: #ffffff;
                            letter-spacing: 0px;
                          "
                        >
                         {{about.heading}}
                        </span></v-flex>
                    </v-layout>
                    <br>
                  
                    <v-layout justify-center wrap fill-height>
                      <v-flex align-self-center text-left xs12>
                        <span
                          v-if="about.text"
                          style="
                            font-family: poppinssemibold;
                            font-size: 17px;
                            color: #ffffff;
                            letter-spacing: 1px;
                          "
                        >
                          {{about.text}}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-img>
            </v-flex>
          </v-layout></v-card
        >
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
props:["about"],
  data() {
    return {
    };
  },
};
</script>